// Ügyfél-státusz megjelenítési meta (adat-parity: active/pending/inactive) — a lista badge-e, a form
// pill-gombja és az ikon EGYETLEN forrásból. A címke az i18n-ből (clients.statusLabel.*), NEM innen.
import { type ClientStatus } from '@atlas/shared';
import { CheckCircleIcon, ClockIcon, MinusCircleIcon } from '@heroicons/react/24/outline';
import { type ComponentType, type SVGProps } from 'react';

import { type BadgeProps } from '@/components/ui/badge';

export interface ClientStatusMeta {
  /** A lista-badge variánsa. */
  badgeVariant: BadgeProps['variant'];
  /** A form pill-gomb aktív állapotának szín-tónusa. */
  pillActiveClass: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const CLIENT_STATUS_META: Record<ClientStatus, ClientStatusMeta> = {
  active: {
    badgeVariant: 'success',
    pillActiveClass: 'bg-success-soft text-success',
    icon: CheckCircleIcon,
  },
  pending: {
    badgeVariant: 'warning',
    pillActiveClass: 'bg-warning-soft text-warning',
    icon: ClockIcon,
  },
  inactive: {
    badgeVariant: 'muted',
    pillActiveClass: 'bg-sunken text-muted-foreground',
    icon: MinusCircleIcon,
  },
};

/** Ismeretlen (legacy nyers) státuszhoz a „muted" fallback (a lista string státuszt is kaphat). */
export function clientBadgeVariant(status: string): BadgeProps['variant'] {
  return (
    (CLIENT_STATUS_META as Record<string, ClientStatusMeta | undefined>)[status]?.badgeVariant ??
    'muted'
  );
}
